    import React, { useState } from "react";
    import { Row, Col, Select, Button, Card, Tabs, Table, Checkbox } from "antd";
    import { BorderLeftOutlined } from "@ant-design/icons";
    import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts'; // 引入 Recharts 組件

    const { Option } = Select;
    const { TabPane } = Tabs;

    const data = [
        { name: '2024-02', 借書次數: 22 },
        { name: '2024-03', 借書次數: 30 },
        { name: '2024-04', 借書次數: 23 },
        { name: '2024-05', 借書次數: 50 },
        { name: '2024-06', 借書次數: 10 },
    ];

    const columns = [
        { title: '借閱書名', dataIndex: 'bookName', key: 'bookName' },
        { title: '借閱日期', dataIndex: 'borrowDate', key: 'borrowDate' },
        // 其他欄位
    ];
    
    const tabledata = [
        { key: '1', bookName: '書籍 A', borrowDate: '2024-01-01' },
        { key: '2', bookName: '書籍 B', borrowDate: '2024-01-02' },
        { key: '3', bookName: '書籍 C', borrowDate: '2024-01-02' },
        { key: '4', bookName: '書籍 D', borrowDate: '2024-01-02' },
        { key: '5', bookName: '書籍 E', borrowDate: '2024-01-02' },
        { key: '6', bookName: '書籍 F', borrowDate: '2024-01-02' },
        { key: '7', bookName: '書籍 G', borrowDate: '2024-01-02' },
        { key: '8', bookName: '書籍 H', borrowDate: '2024-01-02' },
        { key: '9', bookName: '書籍 I', borrowDate: '2024-01-02' },
        { key: '10', bookName: '書籍 J', borrowDate: '2024-01-02' },
        { key: '11', bookName: '書籍 K', borrowDate: '2024-01-02' },
        { key: '12', bookName: '書籍 L', borrowDate: '2024-01-02' },
        // 更多數據
    ];


    function ReaderService() {
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
        const [pageSize, setPageSize] = useState(5); // 定義狀態
        
        const rowSelection = {
            selectedRowKeys,
            onChange: (newSelectedRowKeys) => {
                setSelectedRowKeys(newSelectedRowKeys);
            },
        };

        const handleSelectAll = (e) => {
            if (e.target.checked) {
                const allRowKeys = tabledata.map(item => item.key); // 全選所有行的key
                setSelectedRowKeys(allRowKeys);
            } else {
                setSelectedRowKeys([]); // 取消全選
            }
        };
        return (
            <div style={styles.readerServiceContainer}>
                <div style={styles.Bar_0}>
                    <h2 style={styles.personalLibraryTitle}>個人書房</h2>
                </div>
                <div style={styles.Bar_1}>
                    <Row align="middle" justify="start">
                        <Col>
                            <h2 style={styles.label}>圖書證號：</h2>
                        </Col>
                        <Col>
                            <Select defaultValue="選擇證號" style={styles.select}>
                                <Option value="1">證號 1</Option>
                                <Option value="2">證號 2</Option>
                            </Select>
                        </Col>
                        <Col>
                            <Button type="primary" style={styles.button_1}>切換</Button>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col span={4}>
                        <div style={styles.Bar_2_1}>
                            <Row>
                                <Col span={24} style={{textAlign: 'left'}}>
                                    通知信箱：
                                </Col>
                                <Col span={24} style={{textAlign: 'left', paddingTop: '10px'}}>
                                    <input placeholder="輸入欲更換的通知信箱"/>
                                </Col>
                                <Col span={24} style={{textAlign: 'left', paddingTop: '10px'}}>
                                    <Button type="primary" style={styles.button_2}>變更</Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={13}>
                        <div style={styles.Bar_2_1}>
                            <Row gutter={16}>
                                <Col span={6}>
                                    <Card title="借閱記錄" bordered={true} style={styles.card} headStyle={styles.cardTitle1}>
                                        <p>0本借閱中 /</p>
                                        <p>本逾期</p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card title="預約記錄" bordered={true} style={styles.card} headStyle={styles.cardTitle2}>
                                        <p>1本預約中 /</p>
                                        <p>1本預約到館</p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card title="欠款記錄" bordered={true} style={styles.card} headStyle={styles.cardTitle3}>
                                        <p></p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card title="圖書推薦" bordered={true} style={styles.card} headStyle={styles.cardTitle4}>
                                        <p>前往圖書推薦</p>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={7}>
                        <div style={styles.Bar_2_2}>
                            <LineChart
                                    width={300}
                                    height={200}
                                    data={data}
                                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Line type="monotone" dataKey="借書次數" stroke="#8884d8" activeDot={{ r: 8 }} />
                            </LineChart>
                        </div>
                    </Col>
                </Row>
                <div style={styles.Bar_0}>
                    <Tabs defaultActiveKey="1" style={{paddingLeft: '10px'}}>
                        <TabPane tab="借閱記錄/續借" key="1" style={{paddingLeft: '10px'}}>
                        <Row>
                            <Col span={12} style={{textAlign: 'left'}}>
                                <Checkbox onChange={handleSelectAll} checked={selectedRowKeys.length === tabledata.length}>全選/取消全選</Checkbox>
                                <Button type="primary" style={styles.button_1}>
                                    續借勾選項目
                                </Button>
                            </Col>
                            <Col span={12} style={{textAlign: 'Right',  paddingRight: '10px'}}>
                                <span style={{ paddingRight: '5px' }}>每頁顯示</span>
                                <Select value={pageSize} style={{ width: 80 }} onChange={(value) => setPageSize(value)}>
                                    <Option value="5">5</Option>
                                    <Option value="10">10</Option>
                                    <Option value="20">20</Option>
                                    <Option value="30">30</Option>
                                </Select>
                                <span style={{ paddingLeft: '5px' }}>筆</span>
                            </Col>
                        </Row>
                        <Table
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={tabledata}
                            // pagination={{ pageSize: 10 }}
                            pagination={{ pageSize: pageSize }}
                            style={{ marginTop: '10px' }}
                        />
                        {/* <Row style={{ marginTop: '10px' }}>
                            <Col span={24}>
                            <span>每頁顯示</span>
                            <Select value={pageSize} style={{ width: 60, marginLeft: '10px' }} onChange={(value) => setPageSize(value)}>
                                <Option value="5">5</Option>
                                <Option value="10">10</Option>
                                <Option value="20">20</Option>
                                <Option value="30">30</Option>
                            </Select>
                            <span>筆</span>
                            </Col>
                        </Row> */}
                        </TabPane>
                        <TabPane tab="預約記錄" key="2">
                        {/* 其他 TabPane 內容 */}
                        </TabPane>
                        <TabPane tab="欠款明細" key="3">
                        {/* 其他 TabPane 內容 */}
                        </TabPane>
                        <TabPane tab="歷史借書記錄" key="4">
                        {/* 其他 TabPane 內容 */}
                        </TabPane>
                        <TabPane tab="歷史還款記錄" key="5">
                        {/* 其他 TabPane 內容 */}
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        );
    }

    export default ReaderService;

    // 樣式定義放在組件的最下面
    const styles = {
        readerServiceContainer: {
            textAlign: 'center',
        },
        Bar_0: {
            backgroundColor: '#f9f9f9',
            padding: '10px 0',
            borderBottom: '1px solid #ddd',
        },
        personalLibraryTitle: {
            color: '#007bff',
            fontSize: '18px',
            margin: 0,
        },
        Bar_1: {
            backgroundColor: '#f0f0f0',
            padding: '10px 20px',
            borderBottom: '1px solid #ddd',
        },
        label: {
            marginRight: '8px',
            fontSize: '16px',
            color: '#000',
        },
        select: {
            width: '150px',
            marginRight: '10px',
        },
        button_1: {   
            backgroundColor: '#007bff', // 自定義藍色
            color: '#fff', // 文字顏色設為白色
            border: 'none', // 移除邊框
            marginLeft: '10px',
        },
        Bar_2_1: {
            backgroundColor: '#f9f9f9',
            padding: '10px 20px',
            borderRight: '3px solid #f0f0f0', 
            height: '250px',
        },
        Bar_2_2: {
            backgroundColor: '#f9f9f9',
            padding: '10px 20px', 
            height: '250px',
        },
        button_2: {   
            backgroundColor: '#8fbb57', // 自定義
            color: '#fff', // 文字顏色設為白色
            border: 'none', // 移除邊框
        },
        card: {
            borderRadius: '8px', // 圓角
            height: '200px',
        },
        cardTitle1: {
            backgroundColor: '#e0f7fa', // 淡藍色背景
        },
        cardTitle2: {
            backgroundColor: '#fff9c4', // 淡黃色背景
        },
        cardTitle3: {
            backgroundColor: '#ffe0e0', // 淡粉色背景
        },
        cardTitle4: {
            backgroundColor: '#c8e6c9', // 淡綠色背景
        },
    };
